import { Box, Button, Grid, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Select, Text, useDisclosure, useToast, } from '@chakra-ui/react'
import MyDiv from './leaveBalanceModal.style'
import { useState } from 'react';
// import ImportLeaveBalance from '../ImportLeaveBalance';
import { useFetch } from '../../../../hooks/useFetch';
import { CustomToast } from '../../../../components';


type UpdateType = 'Add' | 'Delete';
type LeaveKey = 'casual' | 'sick' | 'earned' | 'birthday' | 'maternity';
type LeaveValues = Record<LeaveKey, number>;

interface Iprops {
  onClose: () => void;
  employeeBalanaceLeave: any
}

const LeaveBalanceModal = (props: Iprops) => {
  const { onClose } = useDisclosure()
  // const [step, setStep] = useState(1);
  // const [files, setFiles] = useState<any | null>(null);
  const toast = useToast();
  const [updateType, setUpdateType] = useState<UpdateType>('Add');
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [addValues, setAddValues] = useState<LeaveValues>({
    casual: 0, sick: 0, earned: 0, birthday: 0, maternity: 0,
  });

  const [deleteValues, setDeleteValues] = useState<LeaveValues>({
    casual: 0, sick: 0, earned: 0, birthday: 0, maternity: 0,
  });

  const calculateUpdated = (key: LeaveKey) => {
    const current = getCurrentBalance(key);
    const addVal = addValues[key];
    const delVal = deleteValues[key];

    if (updateType === 'Add') return current + addVal;
    if (updateType === 'Delete') return Math.max(0, current - delVal);
    return current;
  };


  const getCurrentBalance = (key: LeaveKey) => {
    const emp = props.employeeBalanaceLeave;
    switch (key) {
      case 'casual': return emp?.balance_CL ?? 0;
      case 'earned': return emp?.balance_EL ?? 0;
      default: return 0;
    }
  };


  const handleChange = (key: LeaveKey, value: string) => {
    const numValue = Number(value);
    if (updateType === 'Add') {
      setAddValues(prev => ({ ...prev, [key]: numValue }));
    } else if (updateType === 'Delete') {
      setDeleteValues(prev => ({ ...prev, [key]: numValue }));
    }
  };

  const leaveTypes: { label: string; key: LeaveKey }[] = [
    { label: 'Casual Leave', key: 'casual' },
    // { label: 'Sick Leave', key: 'sick' },
    { label: 'Earned Leave', key: 'earned' },
    // { label: 'Birthday Leave', key: 'birthday' },
    // { label: 'Maternity Leave', key: 'maternity' },
  ];


  // const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const uploadedFile = e.target.files?.[0]; // take only first file
  //   if (!uploadedFile) return;

  //   const sizeMB = uploadedFile.size / (1024 * 1024);
  //   if (sizeMB > 25) {
  //     toast({
  //       title: "File too large.",
  //       description: `${uploadedFile.name} is over 25MB and was skipped.`,
  //       status: "error",
  //       duration: 3000,
  //       isClosable: true,
  //     });
  //     return;
  //   }

  //   const newFile = {
  //     file: uploadedFile,
  //     name: uploadedFile.name,
  //     size: `${sizeMB.toFixed(1)} MB`,
  //     progress: 0,
  //   };

  //   setFiles(newFile);
  //   setStep(2);

  //   // Simulate upload progress
  //   const interval = setInterval(() => {
  //     setFiles((prev: any) => {
  //       if (!prev) return prev;
  //       if (prev.progress < 100) {
  //         return { ...prev, progress: prev.progress + 10 };
  //       } else {
  //         clearInterval(interval);
  //         return prev;
  //       }
  //     });
  //   }, 200);
  // };

  // const handleFile = (file: File) => {
  //   const sizeMB = file.size / (1024 * 1024);
  //   if (sizeMB > 25) {
  //     toast({ title: "File too large.", description: "The file size must be under 25MB.", status: "error", duration: 3000, isClosable: true, });
  //     return;
  //   }

  //   const newFile = {
  //     name: file.name,
  //     size: `${sizeMB.toFixed(1)} MB`,
  //     progress: 0
  //   };

  //   setFiles((prev: any) => [...prev, newFile]);
  //   setStep(2);
  //   const interval = setInterval(() => {
  //     setFiles((prev: any) => {
  //       const updated = [...prev];
  //       const fileIndex = updated.findIndex(f => f.name === file.name);
  //       if (updated[fileIndex].progress < 100) {
  //         updated[fileIndex].progress += 10;
  //       } else {
  //         clearInterval(interval);
  //       }
  //       return updated;
  //     });
  //   }, 200);
  // };

  // const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
  //   e.preventDefault();
  //   const droppedFiles = Array.from(e.dataTransfer.files || []);
  //   if (droppedFiles.length > 0) {
  //     droppedFiles.forEach(file => handleFile(file));
  //   }
  // };

  // const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
  //   e.preventDefault();
  // };

  // const resetImport = () => {
  //   setFiles([]);
  //   setStep(1);
  // };

  // const uploadLeaveFile = async () => {
  //   if (files.length === 0) {
  //     toast({ title: "No file selected", description: "Please select a file to upload", status: "warning", duration: 3000, isClosable: true, });
  //     return;
  //   }
  //   try {
  //     const formData = new FormData();
  //     files.forEach((fileObj: any) => {
  //       formData.append("files", fileObj.file || fileObj);
  //     });

  //     formData.append("employeeId", props.employeeBalanaceLeave?.id);
  //     const response = await fetch("/api/leave/uploadFile", {
  //       method: "POST",
  //       body: formData,
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to upload file");
  //     }
  //     const data = await response.json();
  //     toast({ title: "Success", description: "File uploaded successfully", status: "success", duration: 3000, isClosable: true, });
  //     resetImport();
  //   } catch (error: any) {
  //     toast({ title: "Error", description: error.message || "Something went wrong", status: "error", duration: 3000, isClosable: true, });
  //   }
  // };

  const updateLeaveBalance = async () => {
    const payload: any = { employeeId: props.employeeBalanaceLeave?.employeeId };
    leaveTypes.forEach((leave) => {
      const balance = calculateUpdated(leave.key);
      if (leave.key === 'casual') payload.Balance_CL = balance;
      if (leave.key === 'earned') payload.Balance_EL = balance;
      // if (leave.key === 'sick') payload.Balance_SL = balance;
      // if (leave.key === 'birthday') payload.Balance_BL = balance;
      // if (leave.key === 'maternity') payload.Balance_ML = balance;
    });
    const response = await fetchApi("Hrlense_Leave/updateEmployeeBalanceLeave", "PUT", payload, "", "");
    if (response) {
      toast({ title: "Success", description: "Leave balance updated successfully", status: "success", duration: 3000, isClosable: true, });
      props.onClose();
    }
  };

  return (
    <MyDiv>
      <Grid className='grid_input'>
        <Text className='font-poppins text_medium text_sm'>Update Type</Text>
        <Select
          bg='rgba(245, 245, 245, 1)'
          value={updateType}
          onChange={(e) => setUpdateType(e.target.value as 'Add' | 'Delete')}
        >
          <option value="Add">Add</option>
          <option value="Delete">Delete</option>
          {/* <option value="Upload">Upload</option> */}
        </Select>

      </Grid>
      <>
        <Grid className="grid_header" mt={2}>
          <Box />
          <Box />
          <Text className='font-poppins font_dark text_md text_medium '>Current Balance</Text>
          <Text className='font-poppins font_dark text_md text_medium '>Updated Balance</Text>
        </Grid>

        {leaveTypes.map((leave) => (
          <Grid className="row" key={leave.key}>
            <Box p={2} minH="40px" display="flex" alignItems="center">
              <Text className='font-poppins text_medium text_sm'>{leave.label}</Text>
            </Box>

            <Box p={2} minH="40px">
              <NumberInput
                size="sm"
                maxW={32}
                min={0}
                value={updateType === "Add" ? addValues[leave.key] : deleteValues[leave.key]}
                onChange={(value) => handleChange(leave.key, value)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </Box>

            <Box className='common_bg' p={2} minH="40px" display="flex" alignItems="center">
              <Text className="font-poppins text_medium text_lg common_color">{getCurrentBalance(leave.key)}
              </Text>
            </Box>

            <Box className='common_bg' p={2} minH="40px" display="flex" alignItems="center">
              <Text className="font-poppins text_medium text_lg common_color" color="#006838">{calculateUpdated(leave.key)}</Text>
            </Box>
          </Grid>
        ))}

        <Box display="flex" justifyContent="center" gap={4} mt={4}>
          <Button colorScheme='green' mr={3} onClick={updateLeaveBalance}>
            Confirm
          </Button>
          <Button variant='ghost' onClick={props.onClose}>Cancel</Button>
        </Box>
      </>


    </MyDiv>
  )
}

export default LeaveBalanceModal

